export const getSuperTuscanData = () => ({
  name: "SuperTuscan",
  country: "Italie",
  description: "Les SuperTuscans sont des vins rouges révolutionnaires de Toscane, nés dans les années 1970 pour défier les règles traditionnelles de l'appellation.",
  type: "region",
  mapAreas: [
    { region: "SuperTuscan", x: 50, y: 45, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "800,000 hl",
    wineries: "200+ domaines",
    villages: "15+ communes",
    exportPercentage: "85%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré, étés chauds et secs",
    soil: "Sols argilo-calcaires, galestro, albarese, sables marins",
    viticulture: "Vendanges manuelles, cépages internationaux et autochtones, IGT"
  },
  wineStyles: {
    red: "Rouges puissants et structurés, assemblages innovants, élevage en barriques"
  },
  history: "Les SuperTuscans sont nés dans les années 1970 avec Sassicaia et Tignanello, révolutionnant la viticulture italienne.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine gastronomique",
  subregions: [
    { name: "Bolgheri", area: "1,200 ha", percentage: "8.0%", description: "Berceau des SuperTuscans" },
    { name: "Maremma", area: "8,000 ha", percentage: "53.3%", description: "Région côtière émergente" },
    { name: "Chianti", area: "3,000 ha", percentage: "20.0%", description: "SuperTuscans traditionnels" },
    { name: "Montalcino", area: "1,500 ha", percentage: "10.0%", description: "Vins de garde" },
    { name: "Autres", area: "1,300 ha", percentage: "8.7%", description: "Dispersés en Toscane" }
  ],
  grapeVarieties: [
    { name: "Cabernet Sauvignon", percentage: "35%", description: "Cépage principal des SuperTuscans" },
    { name: "Merlot", percentage: "25%", description: "Cépage d'assemblage" },
    { name: "Sangiovese", percentage: "20%", description: "Cépage toscan traditionnel" },
    { name: "Cabernet Franc", percentage: "10%", description: "Cépage d'assemblage" },
    { name: "Syrah", percentage: "5%", description: "Cépage moderne" },
    { name: "Autres", percentage: "5%", description: "Cépages mineurs" }
  ]
}); 